import fileSaver from 'file-saver';
import moment from 'moment';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './Testing.type';
import * as Testservice from '../../../../services/testing.service';

export const getAllTest = (params) => async (dispatch) => {
  try {
    const response = await Testservice.getAllTesting(params);
    if (response.code === 200) {
      await dispatch({
        type: t.ALL_TESTS,
        payload: { data: response.data, original: true },
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getTestingGroup = (params) => async (dispatch) => {
  try {
    const response = await Testservice.getAllGrading(params);
    if (response.code === 200) {
      await dispatch({
        type: t.ALL_GROUPS,
        payload: response.data,
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getDataForEdit = (params) => async (dispatch) => {
  try {
    const response = await Testservice.getOneGrading(params);
    if (response.code === 200) {
      await dispatch({
        type: t.ONE_GROUP,
        payload: response.data,
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getTestingLibrary = (params) => async (dispatch) => {
  try {
    const response = await Testservice.getAllTestLibrary(params);
    if (response.code === 200) {
      if (params.from === 'search') {
        await dispatch({
          type: t.ALL_OPTIONS,
          payload: response.data,
        });
      } else {
        await dispatch({
          type: t.ALL_LIBRARY,
          payload: response.data,
        });
      }
    } else {
      toasterMsg(response.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getArchivedTests = (params) => async (dispatch) => {
  try {
    const response = await Testservice.getArchiveReports(params);
    if (response.code === 200) {
      await dispatch({
        type: t.ALL_ARCHIVED,
        payload: response.data,
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const addNewTests = (params, transactionMsg) => async () => {
  try {
    const response = await Testservice.addNewTest(params);
    if (response.code === 200) {
      toasterMsg(transactionMsg(response.message), 'success');
    } else {
      toasterMsg(transactionMsg(response.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const addNewTestGroups = (params, transactionMsg) => async (dispatch) => {
  try {
    const response = await Testservice.addNewTestGroup(params);
    if (response.code === 200) {
      const msg = transactionMsg(`TESTING.${response.message}`);
      toasterMsg(msg, 'success');
      return await dispatch({
        type: t.ON_ADD_DATA,
        payload: response.data,
      });
    }
    toasterMsg(response.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const selectedIds = (params) => async (dispatch) => {
  try {
    return await dispatch({
      type: t.SELECTED_IDS,
      payload: params,
    });
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const addNewFile = (params, trans) => async () => {
  try {
    const response = await Testservice.uploadFile(params);
    if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(trans(`TESTING.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(trans(`TESTING.${response.message}`), 'danger');
    } else {
      toasterMsg(trans(response?.data?.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const updateTesting = (params, transactionMsg) => async () => {
  try {
    const response = await Testservice.updateTesting(params);
    if (response.code === 200) {
      const msg = transactionMsg(`TESTING.${response.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${response.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const updateTestingGroups = (params, transactionMsg) => async () => {
  try {
    const response = await Testservice.updateTestingGroup(params);
    if (response.code === 200) {
      const msg = transactionMsg(`TESTING.${response.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`TESTING.${response.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const StatusChange = (params, transactionMsg) => async () => {
  try {
    const response = await Testservice.statusChanges(params);
    if (response.code === 200) {
      const msg = transactionMsg(`TESTING.${response.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${response.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const deleteTest = (params) => async () => {
  try {
    const response = params.multipleDelete ? await Testservice.multiDeletePom(params) : await Testservice.deleteTesting(params);
    if (response.code === 200) {
      toasterMsg(response.message, 'success');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const deleteTestStatus = (params, transactionMsg) => async () => {
  try {
    const response = await Testservice.deleteTestingStatus(params);
    if (response.code === 200) {
      const msg = transactionMsg(`${response.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const deleteTestGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const response = await Testservice.deleteTestingGroup(params);
    if (response.code === 200) {
      await dispatch({
        type: t.DELETE_TESTING,
      });
      const msg = transactionMsg(`TESTING.${response.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const emptyReducer = () => async (dispatch) => {
  try {
    return await dispatch({
      type: t.EMPTY_REDUCER,
    });
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const updatetestReducer = (data) => async (dispatch) => {
  try {
    if (data) {
      await dispatch({
        type: t.UPDATE_NEW_ORDER_TESTING,
        payload: { data: [...data] },
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteTestReport = (params, transactionMsg) => async (dispatch) => {
  try {
    const response = await Testservice.deleteTestingReport(params);
    if (response.code === 200) {
      const msg = transactionMsg(`TESTING.${'BACKEND_SERVICE.TEST_REPORT_DELETED'}`);
      toasterMsg(msg, 'success');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const downloadTestingLibrary = (data) => async () => {
  try {
    const res = await Testservice.exportExcelService(data);
    if (res) {
      fileSaver.saveAs(res, `Testing Library - ${moment().format('DD-MM-YYYY')}`);
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};
